import React from "react";
import { withRouter } from "react-router-dom";
import "./Style.scss"; 

const BackGroundVideoComponent = (props) => {
  return <div></div>;
};

export default withRouter(BackGroundVideoComponent);
